import React, { FC } from "react";
import BannerVariantPicker from "../BannerVariantPicker";
import { useFormContext, useWatch } from "react-hook-form";
import HashtagSearch from ".././HashtagSearch/HashtagSearch";
import TextStep from "../../components/TextStep/TextStep";
import ImageUploadStep from "../../components/ImageUploadStep";
import TextareaStep from "../../components/TextareaStep/TextareaStep";

interface Props {
	stepNumber: number;
	field: BannerMultiField;
}

const BannerMultiFieldLayout: FC<Props> = ({ stepNumber, field }) => {
	const { control } = useFormContext<BannerFormState>();

	const { bannerStyle, bannerType } = useWatch({ control });

	const isPromotion =
		bannerType === "promotionImage" || bannerType === "promotionVideo";

	// For promotions, only show the link field (no button text/style)
	if (
		isPromotion &&
		(field.field === "buttonText" || field.field === "buttonVariant")
	)
		return null;

	if (!field.type) return null;

	if (bannerStyle === "campaign" && field.field === "buttonLink") return null;

	if (bannerStyle === "standard" && field.field === "buttonHashtagLink")
		return null;

	return (
		<div
			className="flex flex-col justify-start mt-2 mb-4"
			aria-label="multi-field"
		>
			<div className="flex items-center gap-1.5 mb-2 text-zinc-500">
				<span className="text-sm font-medium">{field.label}</span>
			</div>

			{field.type === "radio" && (
				<BannerVariantPicker
					order={field.order}
					stepNumber={stepNumber}
					key={field.order}
					type={field.field}
				/>
			)}

			{field.type === "text" && field.field !== "buttonHashtagLink" && (
				<TextStep stepNumber={stepNumber} order={field.order} />
			)}

			{field.type === "text" &&
				bannerStyle === "campaign" &&
				field.field === "buttonHashtagLink" && (
					<HashtagSearch field={field} stepNumber={stepNumber} />
				)}

			{field.type === "file" && (
				<ImageUploadStep
					stepNumber={stepNumber}
					order={field.order}
					imageProfile={field.imageProfile}
				/>
			)}

			{field.type === "textarea" && (
				<TextareaStep stepNumber={stepNumber} order={field.order} />
			)}
		</div>
	);
};

export default BannerMultiFieldLayout;
